<template>
	<div class="pt-5 pb-5" style="min-height: 100vh; height: auto; background-size: cover; padding-bottom: 20rem">
		<div :style="itemsCart.length > 0 ? 'margin-bottom: 7rem !important' : ''">
			<div class="container d-flex justify-content-center mb-3">
				<div
					class="mr-2 pt-1"
					style="border-radius: 10px"
					v-if="liveMatches.length > 0 || pendingMatches.length > 0"
				>
					<div class="tabs">
						<button
							class="tab-button"
							:class="tab === 'Live' ? 'active' : ''"
							@click="openTab('Live')"
						>
							Live
						</button>
						<button
							class="tab-button"
							:class="tab === 'Pending' ? 'active' : ''"
							@click="openTab('Pending')"
						>
							Coming soon
						</button>
					</div>
					<!-- <b class="text-white px-3">Today Matches</b> -->
				</div>
				<div class="text-center align-items-center mt-5 pt-5" v-else>
					<Loading
						color="#000000"
						size="24"
						class="px-4 py-0 m-auto pb-2 pt-5"
					/>
					<span class="text-dark font-weight-bold">
						ဘောလုံးပွဲစဉ်များအား ရယူနေပါသည်။
					<br>
						ခေတ္တစောင့်ဆိုင်းပေးပါ။
					</span>
				</div>

			</div>
			<div class="container pb-5">
				<div
					class="card work"
					v-for="(item, itemKey) in tab === 'Live'
						? liveMatches
						: pendingMatches"
					:key="itemKey"
					@click="tab === 'Live' ? redirectToLive('video-Links', item) : ''"
				>
					<div class="d-flex flex-column p-3 text-white">
						<div class="d-flex mb-2 justify-content-center">
							<b style="text-align: center">{{ item.league_name }}</b>
						</div>
						<div class="d-flex justify-content-around">
							<div
								class="d-flex flex-column align-items-center"
								style="width: 130px"
							>
								<img :src="item.home_team_logo" />
								<h3 class="pt-2" style="color: #F4F0E8">
									{{ item.home_team_name }}
								</h3>
							</div>
							<div class="d-flex flex-column">
								<div class="mt-4 mb-1 mx-auto">
									<p class="text-white pt-1 my-auto" id="pTag">Vs</p>
								</div>
								<div
									class="mx-auto mt-2"
									v-if="item.match_status.toLowerCase() === 'live'"
								>
									<p class="badge badge-danger pt-2 my-auto live">LIVE</p>
								</div>
								<div
									class="mx-auto mt-2"
									v-if="item.match_status.toLowerCase() !== 'live'"
								>
									<p class="badge badge-info pt-2 my-auto coming">
										{{ formatMyanmarTime(item.match_time) }}
									</p>
								</div>
							</div>
							<div
								class="d-flex flex-column align-items-center"
								style="width: 130px"
							>
								<img :src="item.away_team_logo" />
								<h3 class="pt-2" style="color: #F4F0E8">
									{{ item.away_team_name }}
								</h3>
							</div>
						</div>
					</div>
					<div class="layer">
						<i
							class="fa-solid fa-circle-play text-white"
							style="font-size: 50px !important"
						></i>
						<h5 class="pt-1 text-white">
							Play
						</h5>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Loading } from 'vant';
	export default {
		components: { Loading },
		name: "Live",
		data: () => ({
			itemsCart: [],
			tab: "Live",
			liveMatches: [],
			pendingMatches: [],
		}),
		methods: {
			formatMyanmarTime(timestamp) {
				// timestamp is in seconds → convert to milliseconds
				const date = new Date(timestamp * 1000);

				return date.toLocaleString('en-US', {
					timeZone: 'Asia/Yangon',
					month: 'short',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit',
					hour12: true
				});
			},
			redirectToLive(path, item, isLive) {
				localStorage.setItem('servers', JSON.stringify(item.servers));
				this.$router.push({ path });
			},
			openTab(tabName) {
				this.tab = tabName;
			},
			async redirectRoute(path, query) {
				try {
					console.log("query", query);
					// if (path === 'tip') {
					//   const text = this.$store.state.language === 'en'
					//     ? 'This feature is not support yet.'
					//     : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
					//   Dialog.alert({
					//     message: text,
					//     confirmButtonText:
					//                     this.$store.state.language === 'en'
					//                       ? 'Okay'
					//                       : 'Okay',
					//   }).then(() => {
					//     // on close
					//   });
					// } else {
					this.$router.push({ path, query });
					// }
				} catch (error) {
					console.log(error);
				}
			},
			async fetchMatches() {
				try {
					// const res = await axios.get("https://back.mandalarthu.com/api/football-live-matches-api");
					// // add matches to liveMatches when match_status is live
					// this.liveMatches = res?.data?.data?.filter(
					// 	(match) => match.match_status?.toLowerCase() === "live" && match.servers.length > 0
					// );
					// this.pendingMatches = res?.data?.data?.filter(
					// 	(match) => match.match_status.toLowerCase() !== "live"
					// );
					// this.itemsCart = res.data.data;
				const apiUrl = 'https://footballapi.spacetechmm.com/free-live-matches';

				// Define your API key
				const apiKey = 'kfblaaekjI9MBqUOnUfifsdawAq75WbFg3aL1Xoh85uNqjtfSP6Y13YxHrXvw';

						// Make a GET request using the fetch function with headers
						fetch(apiUrl, {
							method: 'GET',
							headers: {
								'Content-Type': 'application/json',
								'x-api-key': apiKey // Add the x-api-key header
							},
						})
				.then(response => {
				// Check if the request was successful (status code 2xx)
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				// Parse the JSON response
				return response.json();
				})
				.then(data => {
					// add matches to liveMatches when match_status is live
					this.liveMatches = data?.filter(
						(match) => match.match_status?.toLowerCase() === "live" && match.servers.length > 0
					);
					this.pendingMatches = data?.filter(
						(match) => match.match_status.toLowerCase() !== "live"
					);
				})
				.catch(error => {
					// Handle errors
					console.error('Error fetching data:', error);
				});
				} catch (error) {
					console.log(error);
				}
			},
		},
		watch: {
			tab() {
				if (this.tab === "Live") {
				}
			},
		},
		async mounted() {
			this.fetchMatches();
		},
	};
</script>

<style scoped>

/* PAGE */
.pt-5 {
  background: #12101C;
}

/* MATCH CARD */
.card.work {
  position: relative;
  cursor: pointer;
  width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(232, 197, 71, 0.22);
  background: #1E1A32;
  transition: all 0.2s ease;
}

.card.work:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

/* TEAM LOGO */
img {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

/* VS */
#pTag {
  width: 50px;
  height: 28px;
  background: rgba(91, 58, 140, 0.35);
  color: #E8C547 !important;
  font-weight: 600;
  border-radius: 20px;
  text-align: center;
  line-height: 28px;
}

/* PLAY OVERLAY */
.layer {
  opacity: 0;
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: opacity 0.2s ease;
}

.work:hover .layer {
  opacity: 1;
}

.layer i {
  color: #22c55e !important;
}

.layer h5 {
  color: #166534 !important;
  margin-top: 6px;
}

/* BADGES */
.badge.live {
  background: #dcfce7;
  color: #166534 !important;
  font-weight: 600;
  border: 1px solid #22c55e;
}

.badge.coming {
  background: #e0f2fe;
  color: #075985 !important;
  font-weight: 500;
  border: 1px solid #38bdf8;
}

/* REMOVE OLD ANIMATIONS */
.live,
.coming {
  animation: none;
}

/* TABS */
.tabs {
  display: flex;
  background-color: #f9fafb !important;
  border-radius: 999px;
  width: 300px;
  padding: 4px;
  gap: 4px;
  border: 1px solid #e5e7eb !important;
}

.tab-button {
  flex: 1;
  background: transparent;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  padding: 8px 0;
  font-size: 15px;
  font-weight: 500;
  color: #374151 !important;
  transition: all 0.2s ease;
}

.tab-button.active {
  background: #22c55e !important;
  color: #ffffff !important;
}

/* .tab-button:hover {
  background: #dcfce7 !important;
} */
</style>
